/**
 * Auth token storage + retrieval
 * Tokens stored in localStorage; accessToken sent as Bearer header
 */

import type { AuthTokens, User } from '../types/index.js';

const STORAGE_KEY = 'lb_auth';

interface StoredAuth {
  user: User;
  tokens: AuthTokens;
}

export function getStoredAuth(): StoredAuth | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAuth;
    // Discard if access token is expired
    if (parsed.tokens.expiresAt < Date.now()) {
      clearAuth();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function storeAuth(user: User, tokens: AuthTokens): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ user, tokens }));
}

export function clearAuth(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function getAccessToken(): string | null {
  return getStoredAuth()?.tokens.accessToken ?? null;
}

export function getRefreshToken(): string | null {
  return getStoredAuth()?.tokens.refreshToken ?? null;
}
